app.service('finalizeView', function (console, orderConfig, modal, nativeApplicationRateModal, ePaymentBlikModal, subscriptionEncouragement, ePaymentModal, simpleToastr, message, localStorage) {
	const kredytLineRedirectedLocalStorageKey = 'kredytLineRedirected';
	const leasingRedirectedLocalStorageKey = 'leasingRedirected';
	let $self;
	let config, toEPaymentTimeCount, toKredytLineTimeCount, toLeasingTimeCount, orderNumber, type, timeoutId, prefix, instalmentNumber, kredytLine, leasing;

	function setElements() {
		prefix = "";
		$self = $('#finalize #container');
		config = orderConfig.getData();
		orderNumber = config.orderNumber;
		kredytLine = config.kredytLine;
		leasing = config.leasing;
		instalmentNumber = config.instalmentNumber;
		type = config.ePaymentType;
		toEPaymentTimeCount = config.toEPaymentTimeCount; // czas odliczania
		toKredytLineTimeCount = config.kredytLineTimeCount;
		toLeasingTimeCount = config.leasingTimeCount;
		UA.push({
			ppg: {
				positions: config.pluQuantity,
				products: config.productsQuantity
			}
		});
	}

	function setEvents() {
		$('.js-manual-payment-btn').click(function (event) {
			modal.close('EPayment');
			ePaymentModalLoad();
		});

		$('.js-payment-operator-blik-btn').on('click', function () {
			modal.open('EPayment-operator-blik');
		});

		$("#operator-blik-payment").click(function () {
			modal.close('EPayment-operator-blik');
			choosePaymentToLoad();
		});

		$("#operator-blik-cancel").click(function () {
			modal.close('EPayment-operator-blik');
		});

		$('.js-payment-blik-btn').on('click', function () {
			choosePaymentToLoad();
		});

		$(document).on('closing', '#modal-EPayment, #modal-kredytLine-count, #modal-leasing-count', function () {
			stopCountingAutomaticRedirect(); // na zmkniecie modala - przerwac odliczanie!
		});

		$(".js-open-instalmentLayer-modal").click(function () {
			ePaymentModal.goToInstalment(orderNumber);
		});

		$(".js-open-leasing-application").click(function (event) {
			event.preventDefault();
			gotoLeasing();
		});

		$('.js-trade-doubler').on('load', function () {
			tradeDoublerConfirm();
		});
	}

	function choosePaymentToLoad() {
		if (config.ePaymentType == 'PaymentModule') {
			ePaymentModalLoad();
		} else {
			ePaymentBlikModal.load(config.ePaymentType, config.orderNumber);
		}
	}

	function tradeDoublerConfirm() {
		$.ajax({
			type: "GET",
			url: '/order-path-trade-doubler-confirm.ltr',
			data: {
				orderNumber: config.orderNumber
			}
		});
	}

	function showKredytLineMessage() {
		modal.open('kredytLine-count');
		setKredytLineTimeoutToClose();
	}

	function showLeasingMessage() {
		modal.open('leasing-count');
		setLeasingTimeoutToClose();
	}

	function showEPaymentMessage() {

		modal.open('EPayment');

		setEPaymentTimeoutToClose(); // funkcja odliczajaca czas do zamkniecia
		$("#go-to-payment-site").click(function () {
			modal.close('EPayment');
			ePaymentModalLoad();
		});
	}

	function showEPaymentOperatorBlik() {
		modal.open('EPayment-operator-blik');
	}

	function ePaymentModalLoad() {
		ePaymentModal.load({
			type: config.ePaymentType,
			orderNumber: config.orderNumber
		});
	}

	function setEPaymentTimeoutToClose() {
		toEPaymentTimeCount--; console.log("odliczam" + toEPaymentTimeCount);
		var text = 'Płacę';
		if (toEPaymentTimeCount === 0) {
			modal.close('EPayment');
			ePaymentModalLoad();
			$('#modal-EPayment a').text(text);
		}
		else {
			$('#modal-EPayment a').text(text + ' (' + toEPaymentTimeCount + ')');
			timeoutId = setTimeout(function () {
				setEPaymentTimeoutToClose();
			}, 1000);
		}
	}

	function setKredytLineTimeoutToClose() {
		toKredytLineTimeCount--;
		if (toKredytLineTimeCount === 0) {
			gotoKredytLine();
		}
		else {
			timeoutId = setTimeout(function () {
				setKredytLineTimeoutToClose();
			}, 1000);
		}
	}

	function setLeasingTimeoutToClose() {
		toLeasingTimeCount--;
		if (toLeasingTimeCount === 0) {
			gotoLeasing();
		}
		else {
			timeoutId = setTimeout(function () {
				setLeasingTimeoutToClose();
			}, 1000);
		}
	}

	function gotoKredytLine() {
		localStorage.setItem(kredytLineRedirectedLocalStorageKey, orderNumber)
		ePaymentModal.goToInstalment(orderNumber);
	}

	function kredytLineNotInitialized() {
		return orderNumber != localStorage.getItem(kredytLineRedirectedLocalStorageKey)
	}

	function gotoLeasing() {
		stopCountingAutomaticRedirect();
		localStorage.setItem(leasingRedirectedLocalStorageKey, orderNumber);
		ePaymentModal.goToLeasing(orderNumber);
	}

	function leasingNotInitialized() {
		return orderNumber != localStorage.getItem(leasingRedirectedLocalStorageKey);
	}

	function stopCountingAutomaticRedirect() {
		clearTimeout(timeoutId);
	}

	function showMessageIfNeeded() {
		if (config.showSubscriptionEncouragement) {
			subscriptionEncouragement.open();
		} else if (config.ePaymentType && config.toEPaymentTimeCount) {
			if (config.isOperatorMode === true) {
				showEPaymentOperatorBlik();
			} else if (config.ePaymentBlik) {
				ePaymentBlikModal.load(config.ePaymentType, config.orderNumber);
			} else {
				showEPaymentMessage();
			}
		} else if (leasing && config.leasingTimeCount && leasingNotInitialized()) {
			showLeasingMessage();
		} else if (config.kredytLine && config.kredytLineTimeCount && kredytLineNotInitialized()) {
			showKredytLineMessage();
		}
	}

	function showRecurringPaymentMessage(recurringPaymentStatus) {
		const modifierMap = {
			'recurring-card-success': 'success',
			'recurring-blik-success': 'success',
			'add-recurring-fail': 'error'
		};

		const modifier = modifierMap[recurringPaymentStatus];
		if (!modifier) {
			return;
		}

		message.get(`finalize-payment-${recurringPaymentStatus}`)
			.then(function (content) {
				simpleToastr.generate(content, {
					modifier
				});
			})
			.catch(function () {
				console.log('Brak statusu');
			});
	}

	function generatePaymentMessage() {
		const anyPaymentTokenized = config.anyPaymentTokenized;
		const tokenizedPaymentName = config.tokenizedPaymentName;

		if (!tokenizedPaymentName) {
			return;
		}

		const recurringPaymentStatusMap = {
			BLIK_RECURRING: {
				true: 'recurring-blik-success',
				false: 'add-recurring-fail'
			},
			E_CARD_RECURRING: {
				true: 'recurring-card-success',
				false: 'add-recurring-fail'
			}
		};

		if (anyPaymentTokenized === null || typeof anyPaymentTokenized === 'undefined') {
			return;
		}

		const paymentMethodStatuses = recurringPaymentStatusMap[tokenizedPaymentName];
		if (!paymentMethodStatuses) {
			return;
		}

		const recurringPaymentStatus = paymentMethodStatuses[String(anyPaymentTokenized)];
		showRecurringPaymentMessage(recurringPaymentStatus);
	}

	let isOneInit = false;
	function init() {
		setElements();
		UA.orderFinalize();
		nativeApplicationRateModal.init();
		ePaymentBlikModal.init();
		setEvents();
		generatePaymentMessage();
		if (!isOneInit) {
			isOneInit = true;
			if (config.showPopupAfterBuyingMessage) {
				modal.open('after-buying-message');
				$(document).on('closed', '#modal-after-buying-message', function () {
					showMessageIfNeeded();
				});
			} else {
				showMessageIfNeeded();
			}
		}
	}
	return {
		init,
	};
});
